var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.046.716A3.12 3.12 0 0 1 3 0c.753 0 1.472.285 2.053.645.359.222.683.483.947.75.264-.267.588-.528.947-.75C7.527.285 8.247 0 9 0c.72 0 1.478.207 2.06.726.59.527.94 1.322.94 2.382 0 1.587-.943 2.99-2.066 4.114-1.132 1.133-2.515 2.05-3.536 2.667a.77.77 0 0 1-.796 0C4.58 9.272 3.198 8.355 2.066 7.222.943 6.098 0 4.695 0 3.108 0 2.02.433 1.228 1.046.716"
})));
export default SvgHeartFilled;